import { inOptimizelyExperiment, getCookie } from '@zola-helpers/client';

export default inOptimizelyExperiment;

/** DEPRICATED - Please use the zola helpers version */
export function getOptimizelyVariationId(experimentId) {
  // Skip for bots
  const automatedTest = getCookie('automatedTest');
  if (automatedTest) {
    return false;
  }

  // Check if optimizely installed
  if (window.optimizely && window.optimizely.get) {
    const state = window.optimizely.get('state');
    const allExperiments = state.getExperimentStates({ isActive: true });
    const experiment = allExperiments[experimentId];

    if (experiment && experiment.variation) {
      return experiment.variation.id;
    }
    // TODO: What if a user is in the exlusion group?
  }
  return undefined;
}

// TODO: Write tests
/** DEPRICATED - Please use the zola helpers version */
export function triggerExperimentAndGetVariationId(optimizelyConfig) {
  // Skip for bots
  const automatedTest = getCookie('automatedTest');
  if (automatedTest) {
    return false;
  }
  // Check if optimizely installed
  if (window.optimizely && window.optimizely.get) {
    const optimizelyData = window.optimizely.get('data');
    const {
      pageName,
      experimentId,
    } = optimizelyConfig[optimizelyData.projectId];

    /*
      This is important! Since we're manually triggering when a user should be placed in the experiment,
      it is the developer's responsibility to indicate that the user should be included.
      Otherwise, we run the risk of placing users in experiments incorrectly.
      Sometimes you might want to determine if a user is in an variation at a point where you would not
      want to trigger an experiment, for those cases use (getOptimizelyVariationId), not this method.
    */
    window.optimizely = window.optimizely || [];
    window.optimizely.push({
      type: 'page',
      pageName
    });

    const state = window.optimizely.get('state');
    const allExperiments = state.getExperimentStates();
    const experiment = allExperiments[experimentId];

    if (experiment && experiment.variation) {
      return experiment.variation.id;
    }
  }
  return undefined;
}

/** DEPRICATED - Please use the zola helpers version */
export function checkUserInExperiment(experimentId) {
  // Check if optimizely installed
  if (window.optimizely && window.optimizely.get) {
    const state = window.optimizely.get('state');
    const allExperiments = state.getExperimentStates();
    const experiment = allExperiments[experimentId];
    return experiment;
  }
  return undefined;
}

/** DEPRICATED - Please use the zola helpers version */
export function getExperimentData(optimizelyConfig) {
  if (window.optimizely && window.optimizely.get) {
    const optimizelyData = window.optimizely.get('data');
    const {
      pageName,
      experimentId,
      variationId,
    } = optimizelyConfig[optimizelyData.projectId];
    return {
      pageName,
      experimentId,
      variationId,
    };
  }
  return {
    pageName: undefined,
    experimentId: undefined,
    variationId: undefined,
  };
}



// WEBPACK FOOTER //
// ./src/util/optimizelyHelper.js